import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDefineUserRole, useFormatMessage } from '../../../../../hooks';
import { ICompany } from '../../../../../interfaces/companies';
import { IUser, UserRoleType } from '../../../../../interfaces/user';
import { IStore } from '../../../../../interfaces/store';

export const getInitialValues = (
  role: UserRoleType,
  me?: IUser,
  company?: ICompany
): {
  email: string;
  role: UserRoleType;
  phoneNumbers: string;
  company: ICompany | null | undefined;
  categories: string[];
  stores: IStore[];
} => {
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const newCompany = (isBuyer || isVendor) && me?.company ? me?.company : company;

  return {
    email: '',
    role,
    company: newCompany,
    phoneNumbers: '',
    categories: [],
    stores: [],
  };
};

export const useFormikUserInvite = (
  role: UserRoleType,
  fetchInvite: (data: {
    role: string;
    email: string;
    login?: string;
    company_id?: string | undefined;
  }) => void,
  me?: IUser,
  company?: ICompany
) => {
  const fm = useFormatMessage();

  return useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(role, me, company),
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required(fm('USER.EDIT.EMAIL.REQUIRED'))
        .email(fm('USER.EDIT.EMAIL.INCORRECT'))
        .nullable(),
      company: me?.is_admin
        ? Yup.object().required(fm('AUTH.VALIDATION.REQUIRED_FIELD'))
        : Yup.object().notRequired(),
    }),

    onSubmit: values => {
      const data = {
        role,
        email: values.email,
        // login: values.email,
        company_id: values?.company?.id?.toString(),
      };
      fetchInvite(data);
    },
  });
};
